<template>
    <Content class="row">
        <div class="sidebar-overlay"></div>
        <div class="sidebar-toggle">
            <i class="icon-sliders"></i>
            <span
                style="position: absolute; top: 38%; right: 0; left: 0; display: block; font-size: 0.9rem; text-transform: uppercase"
            >
                Filtros
            </span>
        </div>

        <!-- FILTROS -->
        <aside
            class="sidebar-shop col-lg-3 order-lg-first mobile-sidebar"
            id="filters-sidebar"
        >
            <form @submit.prevent>
                <!-- <input type="hidden" name="order" value="{{$order}}" /> -->

                <sidebar-wrapper class="sidebar-wrapper">
                    <FilterItem
                        filterLabel="Categorias"
                        filterId="widget-body-categories"
                    >
                        <ul class="cat-list scroll-filter">
                            <li v-if="category && category.cat_name">
                                <a
                                    style="text-transform: capitalize"
                                    :href="route_category_find"
                                >
                                    Mostrar todas as categorias
                                </a>
                            </li>
                            <template v-for="sub in lista_categorias">
                                <li
                                    v-if="
                                        sub.total_products >= 0 &&
                                            sub.id !=
                                                (category && category.id ? category.id : 0)
                                    "
                                    :key="sub.id"
                                >
                                    <a
                                        style="text-transform: capitalize"
                                        :href="
                                            `${route_category_find}/${sub.id}/${sub.cat_slug}`
                                        "
                                    >
                                        {{ sub.cat_name }}
                                        <span>{{ sub.total_products }}</span>
                                    </a>
                                </li>
                            </template>
                        </ul>
                    </FilterItem>

                    <FilterItem
                        v-if="price_ranges.length"
                        filterLabel="Preços"
                        filterId="widget-body-prices"
                    >
                        <ul>
                            <template v-for="(pr, key) in price_ranges">
                                <li v-if="pr.active" :key="key">
                                    <input
                                        :id="`price_range_${pr.id}`"
                                        type="checkbox"
                                        v-model="pr.checked"
                                        @change="getProducts"
                                    />
                                    <!--
                                        onchange="unchecked({{$key}}, {{$price_ranges}}, event)"
                                        {{ (isset($filters_selected['amount']) ? (
                                            ("$item->initial_price". "/".(!empty($item->end_price) ? $item->end_price : '')) == $filters_selected['amount']
                                            ? 'checked="checked"' : ''
                                        ) : '') }}
                                        :value="`${pr.initial_price}/${pr.end_price ? pr.end_price : ''}`"
                                    -->
                                    <label
                                        v-if="pr.end_price"
                                        :for="`price_range_${pr.id}`"
                                    >
                                        {{ currency.money(pr.initial_price) }} a
                                        {{ currency.money(pr.end_price) }}
                                    </label>
                                    <label v-else :for="`price_range_${pr.id}`">
                                        Acima de
                                        {{ currency.money(pr.initial_price) }}
                                    </label>
                                </li>
                            </template>
                        </ul>
                    </FilterItem>

                    <FilterItem
                        v-if="sizes.length"
                        filterLabel="Tamanhos"
                        filterId="widget-body-sizes"
                    >
                        <ul class="config-size-list">
                            <!-- @foreach ($sizes as $size)
                                <li class="{{  (isset($filters_selected['sizes']) && in_array($size->id, $filters_selected['sizes'])) ?  'active' : null}}">
                                    <input
                                        type="checkbox"
                                        name="filter[sizes][]"
                                        value="{{$size->id}}"
                                        style="opacity: 0;"
                                        id="size{{$size->id}}"
                                        {{  (isset($filters_selected['sizes']) && in_array($size->id, $filters_selected['sizes'])) ?  'checked="checked"' : null}}
                                    />
                                    <label for="size{{$size->id}}" style="margin-left:-12px">{{$size->description}}</label>
                                </li>
                            @endforeach -->
                        </ul>
                    </FilterItem>

                    <FilterItem
                        v-if="brands.length"
                        filterLabel="Marcas"
                        filterId="widget-brand-4"
                    >
                        <ul class="cat-list scroll-filter">
                            <li
                                v-for="brand in brands"
                                :key="brand.id"
                                :class="{active: false}"
                            >
                            <!-- class="{{  (isset($filters_selected['brands'])) && in_array($item->brand_name, $filters_selected['brands']) ?  'active"' : null}}" -->
                                <input
                                    type="checkbox"
                                    v-model="brand.checked"
                                    :id="`brand-${brand.id}`"
                                    @change="getProducts"
                                />
                                <!-- {{  (isset($filters_selected['brands'])) && in_array($item->brand_name, $filters_selected['brands']) ?  'checked="checked"' : null}} -->
                                <label style="text-transform: capitalize" :for="`brand-${brand.id}`">
                                    {{ brand.brand_name }}
                                </label>
                                <span style="float:right">{{ brand.total_products }}</span>
                            </li>
                        </ul>
                    </FilterItem>

                    <!-- FILTRO  CORES -->
                    <!-- @if(!empty($colors))
                        <div class="widget">
                            <widget-title-filter>
                                <a data-toggle="collapse" href="#widget-body-colors" role="button" aria-expanded="true" aria-controls="widget-body-colors">Cores</a>
                            </widget-title-filter>

                            <div class="collapse show" id="widget-body-colors">
                                <div class="widget-body">
                                    <ul class="config-swatch-list row" style="display: flex">
                                        @foreach ($colors as $color)
                                            @php
                                                $active = (isset($filters_selected['colors']) && in_array($color->id, $filters_selected['colors']))
                                            @endphp
                                            <li class="{{  (isset($filters_selected['colors']) && in_array($color->id, $filters_selected['colors'])) ?  'active' : null}}">
                                                <input
                                                    type="checkbox"
                                                    name="filter[colors][]"
                                                    value="{{$color->id}}"
                                                    style="display:none;"
                                                    id="color{{$color->id}}"
                                                    {{  (isset($filters_selected['colors']) && in_array($color->id, $filters_selected['colors'])) ?  'checked="checked"' : null}}
                                                />
                                                @if ($color->cod_exa2 && $color->type == 'COLOR')
                                                    <label for="color{{$color->id}}" style="overflow:hidden; position:relative; border:1px solid #dae2e6; margin: 0; border-radius: 50%; width: 30px; height: 30px;">
                                                        <div style="position:absolute; top: -7px; left: -1px; transform: rotate(30deg); height:4rem; width:1.5rem; background-color:{{ $color->cod_exa }}"></div>
                                                        <div style="position:absolute; top: 0px; right: -1px; transform: rotate(30deg); height:4rem; width:1.7rem; background-color:{{ $color->cod_exa2 }}"></div>
                                                    </label>
                                                @endif
                                                @if (!$color->cod_exa2 && $color->type == 'COLOR')
                                                    <label for="color{{$color->id}}" style="background-color: {{$color->cod_exa}}; border:1px solid #dae2e6; margin: 0; width: 30px; height: 30px; border-radius: 50%;"></label>
                                                @endif
                                                @if ($color->type == 'ESTAMPA')
                                                    <label style="border:1px solid #dae2e6; margin: 0; border-radius: 50%; width: 30px; height: 30px;" for="color{{$color->id}}">
                                                        <img width="28" height="28" style="border-radius: 50%" loading="lazy" alt="{{$color->name}}" data-src="{{$color->url_image}}">
                                                    </label>
                                                @endif
                                            </li>
                                        @endforeach
                                    </ul>
                                </div>
                            </div>
                        </div>
                    @endif -->

                    <!-- @if(!empty($products))
                        <div class="widget">
                            <widget-title-filter>
                                <a data-toggle="collapse" href="#widget-body-options" role="button" aria-expanded="true" aria-controls="widget-body-options">Opções</a>
                            </widget-title-filter>
                            <div class="collapse show" id="widget-body-options">
                                <div class="widget-body">
                                    @php
                                        function hasOption($products, $column, $column2 = null) {
                                            if(array_search(true, array_column((array)$products->items(), $column)) !== false ) {
                                                return true;
                                            } elseif(!empty($column2)) {
                                                $promotions = array_column((array)$products->items(), $column2);
                                                if(count($promotions) > 0) {
                                                    return true;
                                                }
                                            }
                                            return false;
                                        }
                                    @endphp
                                    <ul class="">
                                        <li>
                                            <input
                                                type="checkbox"
                                                name="filter[options][pro_featured]"
                                                value="true"
                                                id="pro_featured1"
                                                {{  (isset($filters_selected['options']['pro_featured'])) ?  'checked="checked"' : null}}
                                            />
                                            <label for="pro_featured1">Em destaque</label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                name="filter[options][pro_bestseller]"
                                                value="true"
                                                id="pro_bestseller1"
                                                {{  (isset($filters_selected['options']['pro_bestseller'])) ?  'checked="checked"' : null}}
                                            />
                                            <label for="pro_bestseller1">Mais vendidos</label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                name="filter[options][pro_new_product]"
                                                value="true"
                                                id="pro_new_product1"
                                                {{  (isset($filters_selected['options']['pro_new_product'])) ?  'checked="checked"' : null}}
                                            />
                                            <label for="pro_new_product1">Produto novo</label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                name="filter[options][pro_sale]"
                                                value="true"
                                                id="pro_sale1"
                                                {{  (isset($filters_selected['options']['pro_sale'])) ?  'checked="checked"' : null}}
                                            />
                                            <label for="pro_sale1">Em promoção</label>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    @endif -->
                </sidebar-wrapper>
            </form>
        </aside>

        <div class="col-lg-9">
            <primary-title>{{ titlePage }}</primary-title>

            <form>
                <nav class="toolbox">
                    <div class="toolbox-left">
                        <div class="toolbox-item toolbox-sort">
                            <select-custom class="select-custom">
                                <select
                                    name="order"
                                    class="form-control"
                                    v-model="order"
                                >
                                    <option
                                        v-for="op in optionsOrder"
                                        :key="op.value"
                                        :value="op.value"
                                    >
                                        {{ op.label }}
                                    </option>
                                </select>
                            </select-custom>
                            <!-- <select-custom class="select-custom">
                                <select name="order" class="form-control" onchange="this.form.submit()">
                                    <option value="destaque" {{ $order == 'destaque' ? 'selected' : null}}>Destaque</option>
                                    <option value="produto_a-z" {{ $order == 'produto_a-z' ? 'selected' : null}}>Produto A-Z</option>
                                    <option value="produto_z-a" {{ $order == 'produto_z-a' ? 'selected' : null}}>Produto Z-A</option>
                                    <option value="preco_menor" {{ $order == 'preco_menor' ? 'selected' : null}}>Preço (menor < maior)</option>
                                    <option value="preco_maior" {{ $order == 'preco_maior' ? 'selected' : null}}>Preço (maior > menor)</option>
                                    <option value="produto_novo" {{ $order == 'produto_novo' ? 'selected' : null}}>Produto novo</option>
                                    <option value="mais_vendidos" {{ $order == 'mais_vendidos' ? 'selected' : null}}>Mais vendidos</option>
                                </select>
                            </select-custom> -->
                        </div>
                    </div>
                    <!-- @if (!empty($search_term))
                        <div class="toolbox-left">
                            <strong style="margin-right: 10px;font-weight: 500;font-size: 28px;color:{{$company['styled']['primary_color']}};">
                                {{$search_term}}
                            </strong>
                            <small>

                                @if ($products->total() <= 0)
                                    (Nenhum produto encontrado)
                                @elseif($products->total() == 1)
                                    ({{$products->total()}} produto encontrado)
                                @elseif($products->total() > 1)
                                    ({{$products->total()}} produtos encontrados)
                                @endif

                            </small>
                        </div>
                    @endif -->

                    <!-- <div class="toolbox-item toolbox-show">
                        @include('components.total_pagination', ['paginator' => $products])
                    </div> -->

                    <!-- {{-- <div class="layout-modes">
                        <a
                            href="
                                {{ route('search')}}{{!empty($search_term) ? "?term=".$search_term."&" : "?"}}layout_mode=grid{{$products->currentPage() > 1 ? "&page=".$products->currentPage() : null}}
                            "
                            class="layout-btn btn-grid {{ $filters['layout_mode'] === "grid" ? "active" : null }}"
                            title="Grade"
                        >
                            <i class="icon-mode-grid"></i>
                        </a>
                        <a
                            href="
                                {{ route('search')}}{{!empty($search_term) ? "?term=".$search_term."&" : "?"}}layout_mode=list{{$products->currentPage() > 1 ? "&page=".$products->currentPage() : null}}
                            "
                            class="layout-btn btn-list {{ $filters['layout_mode'] === "list" ? "active" : null }}"
                            title="Lista"
                        >
                            <i class="icon-mode-list"></i>
                        </a>
                    </div> --}} -->
                </nav>
            </form>

            <template v-if="products.length">
                <div
                    :class="[
                        filters.layout_mode === 'list' ? 'product-intro' : '',
                        'row row-sm'
                    ]"
                >
                    <LoadingApp :is_full_page="true" :isLoading="isLoading" />
                    <ProductDefault
                        v-for="product in products"
                        :key="product.id"
                        :layout_mode="filters.layout_mode"
                        :pro="product"
                        :wishlist="user.wishlist"
                        :products_settings="company.products_settings"
                    />
                </div>
                <Pagination
                    :source="pagination"
                    @navigate="navigate"
                    :pagination_range="6"
                />
            </template>
            <!-- @if (count($products) > 0)
                <div
                    class="{{ $filters['layout_mode'] === "list" ? " product-intro " : null}} row row-sm"
                >
                    @foreach ($products as $item)
                        <product-default
                            layout_mode="{{ $filters['layout_mode'] }}"
                            :pro="{{ json_encode($item) }}"
                            :wishlist="{{ json_encode($user['wishlist']) }}"
                            :products_settings="{{ json_encode($company['data']->products_settings) }}"
                        >
                        </product-default>
                    @endforeach
                </div>
                {{ $products->appends(Request::except('page'))->links('components.pagination') }}
            @elseif(!empty($search_term))
                <div
                    class="col-lg-9"
                    style="height:calc(50vh);display:flex; align-items:center;justify-content:center"
                >
                    <span>
                        <h2>Sua busca por <span style="color:{{$company['styled']['primary_color']}};">{{$search_term}}</span> não encontrou resultado algum :(</h2>
                    </span>
                </div>
            @else
                <div
                    class="col-lg-12"
                    style="height:calc(50vh);display:flex; flex-direction: column; align-items:center;justify-content:center"
                >
                    @if (isset($company['data']->settings['block_access_when_user_not_logged_in']) && $company['data']->settings['block_access_when_user_not_logged_in'] && !\Illuminate\Support\Facades\Auth::check())
                        <h2 style="color:{{$company['styled']['primary_color']}};">Faça login para ter acesso aos produtos!</h2>
                        <c-ancora
                            background-color="{{$company['styled']['products']['button']['background_color'] ?? $company['styled']['primary_color']}}"
                            background-color-hover="{{$company['styled']['products']['button']['background_color_hover'] ?? $company['styled']['hover']}}"
                            color="{{$company['styled']['products']['button']['color'] ?? '#fff'}}"
                            color-hover="{{$company['styled']['products']['button']['color_hover'] ?? '#fff'}}"
                            border-color="{{$company['styled']['products']['button']['border_color'] ?? $company['styled']['primary_color']}}"
                            border-color-hover="{{$company['styled']['products']['button']['border_color_hover'] ?? $company['styled']['hover']}}"
                            border-radius="{{$company['styled']['products']['button']['border_radius'] ?? '0'}}"
                            href="{{$viewUrlSite.'/login'}}"
                            padding="0.85rem 2.7rem"
                            class="mb-2"
                            style="font-size: {{$company['styled']['font_size_button']}}"
                        >
                            <span style="'text-transform:'{{$company['styled']['products']['button']['text_transform'] ?? 'uppercase'}}'; font-size:'{{$company['styled']['font_size_button']}}">
                                Entrar
                            </span>
                        </c-ancora>
                    @else
                        <h2 style="color:{{$company['styled']['primary_color']}};">Nenhum resultado encontrado :(</h2>
                    @endif
                </div>
            @endif -->
        </div>
    </Content>
</template>

<script>
import { Content } from "./style";
import FilterItem from "../FilterItem";
import { CPrimaryTitle } from "../../../components/Styles/Components/styled";
import ProductDefault from "../../../components/product/ProductDefault.vue";
import { CSidebarWrapper } from "../../../components/Styles/Product/styled";
import { mapActions, mapState } from "vuex";
import Pagination from "../../../components/Pagination.vue";
import LoadingApp from "../../../components/LoadingApp.vue";
import { CSelectCustom } from "../../../components/Styles/Template/styled";
import Currency from "../../../helpers/parseCurrency";

export default {
    name: "Category",
    props: {
        company: {
            required: true
        },
        filters: {
            required: true
        },
        user: {
            required: true
        },
        cat: {
            required: true
        },
        lista_categorias: {
            default: []
        },
        price_ranges: {
            default: []
        },
        sizes: {
            default: []
        },
        brands: {
            default: []
        },
        route_category_find: {
            required: true
        }
    },
    components: {
        Content,
        FilterItem,
        ProductDefault,
        Pagination,
        LoadingApp,
        "primary-title": CPrimaryTitle,
        "sidebar-wrapper": CSidebarWrapper,
        "select-custom": CSelectCustom
    },
    data() {
        return {
            isLoading: false,
            page: 1,
            amount: "",
            order: "categoria",
            optionsOrder: [
                { label: "Destaque", value: "destaque" },
                { label: "Produto A-Z", value: "produto_a-z" },
                { label: "Produto Z-A", value: "produto_z-a" },
                { label: "Preço menor", value: "preco_menor" },
                { label: "Preço maior", value: "preco_maior" },
                { label: "Produto novo", value: "produto_novo" },
                { label: "Mais vendidos", value: "mais_vendidos" },
                { label: "Por Categoria", value: "categoria"}
            ],
            currency: Currency
        };
    },
    created() {
        console.log(this.cat, this.brands);
        this.setCategory(this.cat);
        this.getProducts();
    },
    methods: {
        ...mapActions("categories", [
            "ActionGetProducts",
            "setProducts",
            "setPagination",
            "setCategory"
        ]),
        getProducts() {
            this.isLoading = true;
            let filters = this.getFilters();

            console.log(this.brands, this.price_ranges)

            this.ActionGetProducts(filters)
                .then(response => {
                    console.log(response);
                    this.isLoading = false;
                    this.setProducts(response.data.data);
                    this.setPagination(response.data);
                })
                .catch(error => {
                    this.isLoading = false;
                    console.log(error);
                });
        },
        getFilters() {
            return {
                page: this.page,
                order: this.order,
                amount: this.amount,
                category_id: this.category?.id ?? null
                /**
                'search_term'       => $request->input('search_term', null),
                'exibir'            => $exibir,
                'colors'            => $request->input('filter.colors', []),
                'sizes'             => $request->input('filter.sizes', []),
                'pro_featured'      => filter_var($request->input('filter.options.pro_featured', false), FILTER_VALIDATE_BOOLEAN),
                'pro_bestseller'    => filter_var($request->input('filter.options.pro_bestseller', false), FILTER_VALIDATE_BOOLEAN),
                'pro_new_product'   => filter_var($request->input('filter.options.pro_new_product', false), FILTER_VALIDATE_BOOLEAN),
                'pro_sale'          => filter_var($request->input('filter.options.pro_sale', false), FILTER_VALIDATE_BOOLEAN),
                'brands'            => $request->input('filter.brands', []),
                'order'             => $request->input('order', 'destaque'),
                'categories'        => $this->getCategories(),
                'category'          => $this->category,
                'amount'            => $request->input('filter.amount', '')
                 */
            };
        },
        navigate(page = this.page) {
            this.page = page;
            this.getProducts();
            window.scroll(0, 0);
        }
    },
    watch: {
        order() {
            this.page = 1;
            this.getProducts();
        }
    },
    computed: {
        ...mapState("categories", ["category", "products", "pagination"]),
        titlePage() {
            return this.category?.cat_name ?? "Categorias";
        },
    }
};
</script>
